import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { ResponseGetDeliveryStatus } from '../interfaces/api/courier';

@Injectable({
  providedIn: 'root',
})
export class CourierService extends BaseService {
  private urlCourier = `${this.apiUrl}/courier`;

  constructor(private http: HttpClient) {
    super();
  }

  getTransactionCourierStatus(transactionId: number) {
    return this.http.get<ResponseGetDeliveryStatus>(`${this.urlCourier}/status_driver/${transactionId}`);
  }
}
